import React from 'react';
import { Checkbox, Form, Input, Radio } from 'antd';
import { formatPhone } from 'common/helpers/phone.helper';
import styles from './edit-notifications-block.module.scss';
import { EditNotificationsBlockProps } from './edit-notifications-block.types';
import { RadioChangeEvent } from 'antd/lib';
import { editNotificationsValidation } from './edit-notifications.validations';
import Feature from '../feature/feature';
import { FeatureName } from 'common/enums/feature-name.enum';
import { NotificationType } from 'common/enums/notification-type.enum';

export const EditNotificationsBlock: React.FC<EditNotificationsBlockProps> = ({
  withEmailInput,
  notificationType,
  onChangeNotificationType,
  form,
}) => {
  const isSMSNotificationEnabled = notificationType === NotificationType.SMS;
  const isEmailNotificationEnabled = notificationType === NotificationType.Email;

  const handleRadioChange = ({ target: { value } }: RadioChangeEvent) => {
    if (onChangeNotificationType) {
      onChangeNotificationType(value);
    }
  };

  return (
    <Radio.Group value={notificationType} className="vertical-radio-group" onChange={handleRadioChange}>
      <Feature name={FeatureName.SmsNotifications}>
        <Radio value={NotificationType.SMS}>SMS notification</Radio>
        <div className={`${styles.editNotificationsBlock} ${isSMSNotificationEnabled ? '' : styles.disabled}`}>
          <Form.List name="phones" rules={isSMSNotificationEnabled ? editNotificationsValidation.phones : undefined}>
            {(fields) => {
              return fields.map((field, index) => {
                const phone = form.getFieldValue(['phones', index]);
                return (
                  phone.number &&
                  phone.label && (
                    <div className={styles.phoneNumber} key={`notifications-phone-${index}`}>
                      <Form.Item {...field} name={[field.name, 'isNotificationEnabled']} valuePropName="checked">
                        <Checkbox disabled={!isSMSNotificationEnabled} />
                      </Form.Item>
                      <span>{formatPhone(phone.countryCode, phone.number)}</span>
                      <span className={`eiq-label ${phone.label?.toLowerCase()}`}>{phone.label}</span>
                    </div>
                  )
                );
              });
            }}
          </Form.List>
        </div>
      </Feature>
      <Radio value={NotificationType.Email}>Email notification</Radio>
      {withEmailInput && (
        <Form.Item
          name="email"
          label="Email address"
          className={`${styles.smsNotificationsBody} ${isEmailNotificationEnabled ? '' : styles.disabled}`}>
          <Input name="email" placeholder="Enter email" disabled={!isEmailNotificationEnabled} />
        </Form.Item>
      )}
      <Radio value={NotificationType.Push}>Push notification</Radio>
      <Radio value={NotificationType.Undefined}>Do not disturb</Radio>
    </Radio.Group>
  );
};
